import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matcheckbox',
	templateUrl:'./MatCheckboxPage.html',
	styles: [],
	styleUrls:['./MatCheckboxPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatCheckboxPage
{
	mdContent_244 = `\`\`\`java
import com.jwebmp.plugins.angular.material.checkbox.MatCheckbox;
\`\`\``;
	mdContent_245 = `\`\`\`java
MatCheckbox()
\`\`\``;
	mdContent_246 = `\`\`\`java
MatCheckbox&lt;?&gt; cb = new MatCheckbox&lt;&gt;();
cb.setLabel("Accept terms");
cb.setColor("primary");
cb.setLabelPosition("before");
\`\`\``;
}
